module.exports = __webpack_public_path__ + "img/sub-banner-4.9bd58584.jpg";